/* mtnsense homepage/about animations — port of the ticket-08 proto-d script.
   Smoothed scroll-progress parallax (CTA + badge) and the video lightbox.
   Hero entrances are pure CSS (home.css, ticket 09) and scrolling is native
   (ticket 11). Guarded so multiple section includes run once. */
(function () {
  'use strict';
  if (window.__mtnHomeJs) return;
  window.__mtnHomeJs = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v) {
    return Math.max(0, Math.min(1, v));
  }

  /* ---- smoothed scroll-progress parallax ---- */
  var fxs = [];

  function progress(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    return clamp((vh - r.top) / (vh + r.height));
  }

  function addFx(triggerEl, smoothing, apply) {
    fxs.push({ el: triggerEl, p: progress(triggerEl), tau: smoothing * 3.5, apply: apply, visible: false });
  }

  function initParallax() {
    document.querySelectorAll('.mtn-cta').forEach(function (cta) {
      var bg = cta.querySelector('.mtn-cta-img:not(.is-fg)');
      var fg = cta.querySelector('.mtn-cta-img.is-fg');
      var text = cta.querySelector('.mtn-cta-text');
      addFx(cta, 80, function (p) {
        if (bg) bg.style.transform = 'translate3d(0,' + -240 * (1 - p) + 'px,0)';
        if (fg) fg.style.transform = 'translate3d(0,' + (-170 + 140 * p) + 'px,0) scale(' + (1 + 0.08 * p) + ')';
        if (text) text.style.opacity = clamp((p - 0.05) / 0.41);
      });
    });

    document.querySelectorAll('.mtn-badge-image').forEach(function (badge) {
      addFx(badge.parentElement, 80, function (p) {
        badge.style.transform = 'translate3d(0,' + (81 - 194 * p) + 'px,0) rotate(' + (-29 + 52 * p) + 'deg)';
      });
    });

    if (!fxs.length) return;

    /* The loop is demand-driven, not free-running (ticket 27): an
       IntersectionObserver tracks which triggers are on-screen, scroll /
       resize / viewport entry wake the loop, and it stops itself once every
       visible effect has eased onto its target — so nothing measures or
       paints while the page is idle or the effects are off-screen. */
    var rafId = null;
    var last = 0;

    function tick(now) {
      var dt = Math.min(now - last, 100);
      last = now;
      var settled = true;
      fxs.forEach(function (f) {
        if (!f.visible) return;
        var t = progress(f.el);
        f.p += (t - f.p) * (1 - Math.exp(-dt / f.tau));
        if (Math.abs(t - f.p) < 0.0005) f.p = t;
        else settled = false;
        f.apply(f.p);
      });
      rafId = settled ? null : requestAnimationFrame(tick);
    }

    function wake() {
      if (rafId !== null) return;
      last = performance.now();
      rafId = requestAnimationFrame(tick);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        fxs.forEach(function (f) {
          if (f.el === entry.target) f.visible = entry.isIntersecting;
        });
      });
      wake();
    });
    fxs.forEach(function (f) { io.observe(f.el); });

    /* Capture-phase: at desktop the theme scrolls .page-wrapper (html/body
       are overflow:hidden), and inner scrolls never reach window. */
    document.addEventListener('scroll', wake, { capture: true, passive: true });
    window.addEventListener('resize', wake);
  }

  /* ---- video lightbox: load the embed on open, unload on close so
     playback stops with the modal (the iframe src lives in data-src) ---- */
  function initVideoLightbox() {
    document.querySelectorAll('.mtn-video-lightbox').forEach(function (component) {
      var iframe = component.querySelector('iframe[data-src]');
      if (!iframe) return;
      component.addEventListener('dialog:open', function () {
        iframe.src = iframe.getAttribute('data-src');
      });
      component.addEventListener('dialog:close', function () {
        iframe.src = 'about:blank';
      });
    });
  }

  function init() {
    initVideoLightbox();
    if (!reduced) {
      initParallax();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
